// extracted by css-extract-rspack-plugin
export default {"modalCardImage":"src-app-pages-account-withdraw-BuyRegister-BuyRegister-module__modalCardImage-S0UlfZ"};
    if(module.hot) {
      (function() {
        var localsJsonString = "{\"modalCardImage\":\"src-app-pages-account-withdraw-BuyRegister-BuyRegister-module__modalCardImage-S0UlfZ\"}";
        // 1789362523031
        var cssReload = require("../../../../../../node_modules/@rspack/core/dist/cssExtractHmr.js").cssReload(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  